import useSEO from "@/hooks/useSEO";
import { organizationSchema, SITE_URL } from "@/lib/seo-schemas";
import { SeoHero, SeoSection } from "@/components/SeoBlocks";
import { CopySnippet } from "@/components/CopySnippet";

const BADGES = [
  { id: "dark", file: "/badges/built-by-stagehook-dark.svg", bg: "#07070a" },
  { id: "light", file: "/badges/built-by-stagehook-light.svg", bg: "#f3f3f5" },
];
const snippet = (file) => `<a href="${SITE_URL}/" title="Exhibition stand built by Stagehook Global"><img src="${SITE_URL}${file}" alt="Exhibition stand built by Stagehook Global" width="200" height="56" /></a>`;
const TEXT_LINK = `Our stand was designed and built by <a href="${SITE_URL}/">Stagehook Global, exhibition stand builders</a>.`;

export default function BadgePage() {
  useSEO({
    title: "Built by Stagehook Badge for Clients | Stagehook Global",
    description: "Exhibited with a Stagehook Global stand? Add the 'Built by Stagehook' badge or a credit line to your show recap, press release or news page.",
    path: "/built-by-stagehook",
    jsonLd: [organizationSchema()],
  });
  return (
    <main data-testid="badge-page" className="pb-24">
      <SeoHero eyebrow="For our clients" title="Built by" accent="Stagehook." intro="Writing a show recap, press release or LinkedIn article about your stand? Credit the build with one of these badges or a simple text link. Thank you — it helps other exhibitors find us." />
      {BADGES.map((b) => (
        <SeoSection key={b.id} title={`${b.id === "dark" ? "Dark" : "Light"} badge`} testId={`badge-${b.id}`}>
          <div className="rounded-xl p-8 mb-4 inline-block" style={{ background: b.bg, border: "1px solid var(--line-strong)" }}>
            <img src={b.file} alt="Exhibition stand built by Stagehook Global" width="200" height="56" />
          </div>
          <CopySnippet code={snippet(b.file)} testId={`badge-snippet-${b.id}`} />
        </SeoSection>
      ))}
      <SeoSection title="Text credit" testId="badge-text"><CopySnippet code={TEXT_LINK} testId="badge-snippet-text" /></SeoSection>
    </main>
  );
}
